import { render } from "./ProjectChapterNav.vue?vue&type=template&id=66d8fb91"
import script from "./ProjectChapterNav.vue?vue&type=script&lang=js"
export * from "./ProjectChapterNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__